import { HighlightsInfoModal } from './HighlightsInfoModal';

export default HighlightsInfoModal;
